import PropTypes from 'prop-types'
import { compose, lifecycle, setPropTypes, withStateHandlers } from 'recompose'
import uniqueId from 'lodash/uniqueId'
import isEqual from 'lodash/isEqual'
const withChart = ChartClass =>
  compose(
    setPropTypes({
      data: PropTypes.any.isRequired,
    }),
    withStateHandlers({
      id: uniqueId('__chart'),
    }),
    withStateHandlers(
      { needsRefresh: false },
      {
        setNeedsRefresh: () => refresh => ({ needsRefresh: refresh }),
      }
    ),
    lifecycle({
      updateChart() {
        const { data, id, disableValue, clipPath } = this.props

        const myData = Object.assign({}, data, { disableValue })
        const chartEl = document.getElementById(id)
        this.chart = new ChartClass(chartEl, clipPath)
        this.chart.update(myData)
      },
      componentDidMount() {
        this.updateChart()
      },
      shouldComponentUpdate(newProps) {
        const refreshFlags =
          !isEqual(this.props, newProps) ||
          this.props.needsRefresh ||
          newProps.needsRefresh

        const propsChangedInit =
          !newProps.needsRefresh && !isEqual(this.props, newProps)
        if (propsChangedInit) {
          this.props.setNeedsRefresh(true)

          return false
        }

        const queueRefresh =
          this.props.loanFocus && !newProps.loanFocus && newProps.needsRefresh
        if (queueRefresh) {
          // Force one more pass through this mess with state
          // update after we know the transition animation is done
          setTimeout(() => this.props.setNeedsRefresh(false), 500)

          return false
        }

        return !newProps.loanFocus && refreshFlags
      },
      componentDidUpdate(prevProps) {
        const chartEl = document.getElementById(this.props.id)
        if (chartEl && chartEl.children) {
          ;[...chartEl.children].forEach(child =>
            child.parentNode.removeChild(child)
          )
        }

        this.updateChart()
        prevProps.needsRefresh && this.props.setNeedsRefresh(false)
      },
    })
  )

export default withChart
